(function($) {

  /**
   * Behaviour of the hamburger button
   */

  // init main menu
  var $banner   = $('.banner');
  var $mainmenu = $('.main-navigation');
  $mainmenu.addClass('collapsed');

  // Main navigation Hamburger toggler
  $('.menu-toggler').click(function(){
    if ( $mainmenu.hasClass('expanded') ) {
      $banner.removeClass('menu-open');
      $mainmenu.removeClass('expanded');
      $mainmenu.addClass('collapsed');
    } else {
      $banner.addClass('menu-open');
      $mainmenu.addClass('expanded');
      $mainmenu.removeClass('collapsed');
    }
  });
})(jQuery);